import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=2d691f58&scoped=true"
import script from "./AccordionCard.vue?vue&type=script&lang=js"
export * from "./AccordionCard.vue?vue&type=script&lang=js"
import style0 from "./AccordionCard.vue?vue&type=style&index=0&id=2d691f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d691f58",
  null
  
)

export default component.exports